import { render, staticRenderFns } from "./SupplierManufacturingQuility.vue?vue&type=template&id=3a89f758&scoped=true"
import script from "./SupplierManufacturingQuility.vue?vue&type=script&lang=js"
export * from "./SupplierManufacturingQuility.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a89f758",
  null
  
)

export default component.exports